import React from "react";
import HealthCard from "./HealthCard";
import { formatNumber } from "../utils";

const PLACEHOLDER = {
  percentage: 82,
  delta: -3,
  withinSla: 41,
  breached: 9,
  contractSlaHours: 48,
};

const WorkshopSla = ({ translate, data, loading, apiReady = false }) => {
  const payload = apiReady && data ? data : PLACEHOLDER;
  const percentage = Number(payload.percentage ?? payload.slaPercent ?? 0);
  const delta = Number(payload.delta ?? payload.vsLastMonth ?? 0);
  const withinSla = Number(payload.withinSla ?? 0);
  const breached = Number(payload.breached ?? 0);
  const contractSlaHours = Number(
    payload.contractSlaHours ?? payload.slaHours ?? 0,
  );

  return (
    <HealthCard
      className="fh-span-3"
      title={translate("workshopSlaPerformance") + " --> Api Pending"}
      subtitle={translate("workshopSlaPerformanceSub")}
      loading={loading}
    >
      <div style={{ padding: "16px 0 12px" }}>
        <div className="fh-kpi">
          {formatNumber(percentage)}
          <small>%</small>
        </div>
        <div
          className={`fh-delta ${delta >= 0 ? "up" : "down"}`}
          style={{ marginTop: 4 }}
        >
          {delta >= 0 ? "▲" : "▼"} {Math.abs(delta)}% {translate("vsLastMonth")}
        </div>
      </div>
      <div className="fh-track" style={{ height: 8, marginBottom: 12 }}>
        <div
          className="fh-fill"
          style={{
            width: `${Math.min(percentage, 100)}%`,
            background: "#8fd18f",
          }}
        />
      </div>
      <div className="fh-metaline">
        <span>{translate("withinSla")}</span>
        <b>{formatNumber(withinSla)}</b>
      </div>
      <div className="fh-metaline">
        <span className="flag">{translate("breached")}</span>
        <b className="flag">{formatNumber(breached)}</b>
      </div>
      <div className="fh-metaline">
        <span>{translate("contractSla")}</span>
        <b>{formatNumber(contractSlaHours)} h</b>
      </div>
      {!apiReady ? (
        <div className="fh-coming-soon">{translate("apiPending")}</div>
      ) : null}
    </HealthCard>
  );
};

export default WorkshopSla;
